<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "FieldsetOpeningTime" });
import { SelectSingle } from "../../../../../../../selects/index.js";
import { InputNumber } from "../../../../../../../inputs/index.js";
import { Icon } from "../../../../../../../index.js";
export let value;
export let isDisabled = false;
export let isReadonly = false;
export let remove = void 0;
export let selectedDays;
const ALL_OPTIONS = [
    { key: "monday", label: "Monday" },
    { key: "tuesday", label: "Tuesday" },
    { key: "wednesday", label: "Wednesday" },
    { key: "thursday", label: "Thursday" },
    { key: "friday", label: "Friday" },
    { key: "saturday", label: "Saturday" },
    { key: "sunday", label: "Sunday" }
];
const getDayOptions = () => ALL_OPTIONS.filter(({ key }) => !selectedDays.includes(key) || key === value.weekDay);
$: dayOptions = getDayOptions();
const setWeekDay = () => {
    const AVAILABLE_OPTIONS = getDayOptions();
    if (AVAILABLE_OPTIONS.length > 0) {
        value.weekDay = AVAILABLE_OPTIONS[0].key;
    }
};
setWeekDay();
</script>

<div class = 's8-inputs-fields'>
    <SelectSingle
        bind:key = { value.weekDay }
        label = 'Day'
        placeholder = 'Pick a day'
        name = 'address.openingTimes.weekDay'
        options = { dayOptions }
        isRequired
        { isDisabled }
    />
    <InputNumber
        bind:value = { value.openingTime }
        label = 'Opening Hour'
        placeholder = 'Type an hour'
        name = 'address.openingTimes.opening'
        isRequired
        { isDisabled }
        { isReadonly }
        minimum = { 0 }
        maximum = { 23 }
    />
    <InputNumber
        bind:value = { value.closingTime }
        label = 'Closing Hour'
        placeholder = 'Type an hour'
        name = 'address.openingTimes.closing'
        isRequired
        { isDisabled }
        { isReadonly }
        minimum = { value.openingTime }
        maximum = { 23 }
    />
    <Icon
        key = 'delete'
        on:click = { remove?.bind(null, value.key) }
    />
</div>

<style>

    div.s8-inputs-fields {
        display: grid;
        -moz-column-gap: 10px;
             column-gap: 10px;
        grid-template-columns: 2.5fr 2.5fr 2.5fr 0.25fr;
        align-items: center;
    }

        div.s8-inputs-fields :global(svg) {
            margin-bottom: 12px;
            margin-left: 5px;
        }</style>